import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";

import NanoFlex from "../../../Global/NanoFlex.js";
import WrapperList from "../../../Nano/WrapperList.js";
import TitleCard from "../../../Nano/TitleCard.js";
import Article from "../../../Nano/Article.js";

const StyledVerdictBlock = styled(NanoFlex)`
  .noBorderWrapper {
    border: none;
    padding: 0;
  }
  .titleWrapper {
    h5 {
      width: 100%;
    }
  }
`;

export class VerdictBlock extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    if (!this.props.card.verdict || this.props.card.verdict.trim() === "") return null;

    return (
      <StyledVerdictBlock className="rowContainer verdictBlock">
        <WrapperList simple className="noBorderWrapper">
          <TitleCard simpleTitle={this.translation.card.verdict} />
          <Article article={this.props.card.verdict} />
        </WrapperList>
      </StyledVerdictBlock>
    );
  }
}

//Set default props
VerdictBlock.defaultProps = {
  card: {},
};

export default VerdictBlock;

// --- // Documentation // --- //
/*
  import EvaluationBlock from './../Partial/EvaluationBlock.js';
  
  <EvaluationBlock/>
  */
